//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Features/Features.SelectFeatureList.js";
import "../no/SelectEdgeList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"ChamferAngle",0,"Expression",0],[0,"CornerType",1,0],[0,"FirstVectorForBunnyEar",1,"Direction",0],[1,"Offset",0,"Expression",0],[1,"RadiusDia",0,"Expression",0],[0,"SecondVectorForBunnyEar",1,"Direction",0],[1,"SelectCorner",0,"Features.SelectFeatureList",0],[1,"SelectEdge",0,"SelectEdgeList",0],[0,"SelectFrom",1,0],[0,"Type",1,0]],[],[]];
SPLM.Tooling.CornerDesignBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.CornerDesignBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.CornerDesignBuilder.Types = Object.freeze({
    "Create" : "Create", "Edit" : "Edit", "Delete" : "Delete"});

SPLM.Tooling.CornerDesignBuilder.CornerTypeOpt = Object.freeze({
    "Chamfer" : "Chamfer", "Fillet" : "Fillet", "Mickey" : "Mickey", "BunnyEar" : "BunnyEar"});

SPLM.Tooling.CornerDesignBuilder.SelectFromOpt = Object.freeze({
    "Both" : "Both", "PartBody" : "PartBody", "PocketBody" : "PocketBody"});

export default SPLM;